import { MakeUpAppointmentsList } from '../../features/appointments/MakeUpAppointmentsList';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../core';

export const MakeUpAppointmentsListPage = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Make up Appointments'
  })
)(MakeUpAppointmentsList);
